import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row animated fadeIn"
}
const _hoisted_2 = { class: "col-xl-12 col-lg-12" }
const _hoisted_3 = { class: "card shadow mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }, [
  /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, "Register Withdrawals"),
  /*#__PURE__*/_createVNode("small", { class: "ml-2" }, "Please provide the required information.")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6 text-left" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "form-group text-left" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "bankOrWalletId" }, " Select Account:* ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", {
  disabled: "",
  value: undefined,
  selected: "selected"
}, " Please select ", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("option", { value: 0 }, " Adjustment ", -1)
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "form-group text-left" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "bankOrWalletId" }, " Select Currency:* ", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("option", {
  value: undefined,
  selected: "",
  disabled: ""
}, " Select Currency ", -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "form-group text-left" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "amount" }, " Amount:* ", -1)
const _hoisted_26 = { class: "input-group" }
const _hoisted_27 = { class: "input-group-prepend" }
const _hoisted_28 = { class: "input-group-text" }
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "form-group text-left" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { for: "accountingHour" }, " Accounting Hour: ", -1)
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = { class: "form-group text-left" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { for: "accountingHour" }, " Transaction Auth Code: (optional) ", -1)
const _hoisted_39 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_40 = { class: "col-6 text-left" }
const _hoisted_41 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Account Details ")
const _hoisted_43 = {
  key: 0,
  class: "font-weight-bold text-muted"
}
const _hoisted_44 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_45 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Created At ", -1)
const _hoisted_49 = { class: "col-6 text-right" }
const _hoisted_50 = { style: {"color":"#848696"} }
const _hoisted_51 = {
  key: 0,
  class: "row"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Crypto Address ", -1)
const _hoisted_53 = { class: "col-6 text-right" }
const _hoisted_54 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_55 = { style: {"color":"#848696"} }
const _hoisted_56 = {
  key: 1,
  class: "row"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Recipient FullName ", -1)
const _hoisted_58 = { class: "col-6 text-right" }
const _hoisted_59 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_60 = { style: {"color":"#848696"} }
const _hoisted_61 = {
  key: 2,
  class: "row"
}
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Legal Address Account Holder ", -1)
const _hoisted_63 = { class: "col-6 text-right" }
const _hoisted_64 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_65 = { style: {"color":"#848696"} }
const _hoisted_66 = {
  key: 3,
  class: "row"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Bank Name ", -1)
const _hoisted_68 = { class: "col-6 text-right" }
const _hoisted_69 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_70 = { style: {"color":"#848696"} }
const _hoisted_71 = {
  key: 4,
  class: "row"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Bank Account Number ", -1)
const _hoisted_73 = { class: "col-6 text-right" }
const _hoisted_74 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_75 = { style: {"color":"#848696"} }
const _hoisted_76 = {
  key: 5,
  class: "row"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Swift Or Bic ", -1)
const _hoisted_78 = { class: "col-6 text-right" }
const _hoisted_79 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_80 = { style: {"color":"#848696"} }
const _hoisted_81 = {
  key: 6,
  class: "row"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Transit Number ", -1)
const _hoisted_83 = { class: "col-6 text-right" }
const _hoisted_84 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_85 = { style: {"color":"#848696"} }
const _hoisted_86 = {
  key: 7,
  class: "row"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Institution Number ", -1)
const _hoisted_88 = { class: "col-6 text-right" }
const _hoisted_89 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_90 = { style: {"color":"#848696"} }
const _hoisted_91 = {
  key: 8,
  class: "row"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Bank Address ", -1)
const _hoisted_93 = { class: "col-6 text-right" }
const _hoisted_94 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_95 = { style: {"color":"#848696"} }
const _hoisted_96 = {
  key: 9,
  class: "row"
}
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Phone Number ", -1)
const _hoisted_98 = { class: "col-6 text-right" }
const _hoisted_99 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_100 = { style: {"color":"#848696"} }
const _hoisted_101 = {
  key: 10,
  class: "row"
}
const _hoisted_102 = /*#__PURE__*/_createVNode("div", { class: "col-3 text-left font-weight-bold" }, " Postal Code ", -1)
const _hoisted_103 = { class: "col-3 text-right" }
const _hoisted_104 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_105 = { style: {"color":"#848696"} }
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { class: "col-3 text-left font-weight-bold" }, " City ", -1)
const _hoisted_107 = { class: "col-3 text-right" }
const _hoisted_108 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_109 = { style: {"color":"#848696"} }
const _hoisted_110 = {
  key: 11,
  class: "row"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { class: "col-3 text-left font-weight-bold" }, " Province ", -1)
const _hoisted_112 = { class: "col-3 text-right" }
const _hoisted_113 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_114 = { style: {"color":"#848696"} }
const _hoisted_115 = /*#__PURE__*/_createVNode("div", { class: "col-3 text-left font-weight-bold" }, " Country ", -1)
const _hoisted_116 = { class: "col-3 text-right" }
const _hoisted_117 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_118 = { style: {"color":"#848696"} }
const _hoisted_119 = { class: "card-footer" }
const _hoisted_120 = { class: "container" }
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-md-12 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_amountInput = _resolveComponent("amountInput")
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")

  return (_ctx.user)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _withDirectives(_createVNode("select", {
                            id: "bankOrWalletId",
                            disabled: !_ctx.withdrawalsForm.props.customerId,
                            class: "form-control",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.withdrawalsForm.props.bankOrWalletId = $event)),
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSelectBankOrWalletId && _ctx.onSelectBankOrWalletId(...args)))
                          }, [
                            _hoisted_13,
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userAccounts, (account) => {
                              return (_openBlock(), _createBlock("option", {
                                value: account.id,
                                key: account.id
                              }, _toDisplayString(account.currencyId) + " " + _toDisplayString(account.type === 1 ? 'FIAT' : 'CRYPTO') + " " + _toDisplayString(account.type === 1
                              ? _ctx.formatBankNumber(account.bankAccountNumber)
                              : _ctx.formatCryptoAddress(account.cryptoAddress)), 9, ["value"]))
                            }), 128)),
                            _hoisted_14
                          ], 40, ["disabled"]), [
                            [_vModelSelect, _ctx.withdrawalsForm.props.bankOrWalletId]
                          ]),
                          (_ctx.userAccounts.length === 0)
                            ? (_openBlock(), _createBlock("small", _hoisted_15, _toDisplayString('This account does not have bank account or wallets.'), 1))
                            : _createCommentVNode("", true),
                          (_ctx.withdrawalsForm.controls.bankOrWalletId.dirty)
                            ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.withdrawalsForm.controls.bankOrWalletId.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    (_ctx.isAdjustment)
                      ? (_openBlock(), _createBlock("div", _hoisted_17, [
                          _createVNode("div", _hoisted_18, [
                            _createVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _withDirectives(_createVNode("select", {
                                id: "currencyId",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.withdrawalsForm.props.currencyId = $event)),
                                class: "form-control",
                                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSelectCurrencyId && _ctx.onSelectCurrencyId(...args)))
                              }, [
                                _hoisted_21,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCurrencies, (c) => {
                                  return (_openBlock(), _createBlock("option", {
                                    key: c.id,
                                    value: c.id
                                  }, _toDisplayString(c.id) + " " + _toDisplayString(c.description), 9, ["value"]))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, _ctx.withdrawalsForm.props.currencyId]
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createVNode("div", _hoisted_26, [
                            _createVNode("div", _hoisted_27, [
                              _createVNode("div", _hoisted_28, _toDisplayString(_ctx.currentCurrencyAccount?.id), 1)
                            ]),
                            _createVNode(_component_amountInput, {
                              disabled: 
                            _ctx.withdrawalsForm.props.bankOrWalletId === null
                          ,
                              "onUpdate:amount": _cache[5] || (_cache[5] = ($event: any) => (_ctx.withdrawalsForm.props.amount = $event)),
                              precision: _ctx.currentCurrencyAccount?.exact
                            }, null, 8, ["disabled", "precision"])
                          ]),
                          (_ctx.withdrawalsForm.controls.amount.dirty)
                            ? (_openBlock(), _createBlock("small", _hoisted_29, _toDisplayString(_ctx.withdrawalsForm.controls.amount.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_30, [
                      _createVNode("div", _hoisted_31, [
                        _createVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _withDirectives(_createVNode("input", {
                            class: "form-control",
                            type: "datetime-local",
                            name: "accountingHour",
                            id: "accountingHour",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.withdrawalsForm.props.createdAt = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.withdrawalsForm.props.createdAt]
                          ]),
                          (_ctx.withdrawalsForm.controls.createdAt.dirty)
                            ? (_openBlock(), _createBlock("small", _hoisted_34, _toDisplayString(_ctx.withdrawalsForm.controls.createdAt.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _createVNode("div", _hoisted_36, [
                        _createVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.withdrawalsForm.props.transactionAuthCode = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.withdrawalsForm.props.transactionAuthCode]
                          ]),
                          (
                          _ctx.withdrawalsForm.controls.transactionAuthCode.dirty
                        )
                            ? (_openBlock(), _createBlock("small", _hoisted_39, _toDisplayString(_ctx.withdrawalsForm.controls.transactionAuthCode
                            .errorMessage), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _hoisted_42,
                      (_ctx.currentAccount)
                        ? (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(_ctx.currentAccount.type === 1 ? 'FIAT' : 'CRYPTO') + " " + _toDisplayString(_ctx.currentAccount.currencyId), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (
                    !_ctx.currentAccount &&
                      _ctx.withdrawalsForm.props.bankOrWalletId !== 0
                  )
                      ? (_openBlock(), _createBlock("small", _hoisted_44, " Please Select an Customer Account "))
                      : _createCommentVNode("", true),
                    (_ctx.isAdjustment)
                      ? (_openBlock(), _createBlock("small", _hoisted_45, " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Et id qui nam minima molestias natus commodi rerum velit deleniti, esse quis totam dolorum illum atque, officiis, sed assumenda sit doloremque! "))
                      : _createCommentVNode("", true),
                    (_ctx.currentAccount)
                      ? (_openBlock(), _createBlock("div", _hoisted_46, [
                          _createVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createVNode("div", _hoisted_49, [
                              _createVNode("code", _hoisted_50, _toDisplayString(_ctx.formatDate(_ctx.currentAccount.createdAt)), 1)
                            ])
                          ]),
                          (_ctx.currentAccount.type === 2)
                            ? (_openBlock(), _createBlock("div", _hoisted_51, [
                                _hoisted_52,
                                _createVNode("div", _hoisted_53, [
                                  _createVNode("div", _hoisted_54, [
                                    _createVNode("code", _hoisted_55, _toDisplayString(_ctx.currentAccount.cryptoAddress), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.cryptoAddress
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_56, [
                                _hoisted_57,
                                _createVNode("div", _hoisted_58, [
                                  _createVNode("div", _hoisted_59, [
                                    _createVNode("code", _hoisted_60, _toDisplayString(_ctx.currentAccount.recipientFullName), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.recipientFullName
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_61, [
                                _hoisted_62,
                                _createVNode("div", _hoisted_63, [
                                  _createVNode("div", _hoisted_64, [
                                    _createVNode("code", _hoisted_65, _toDisplayString(_ctx.currentAccount.legalAddressAccountHolder), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.legalAddressAccountHolder
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_66, [
                                _hoisted_67,
                                _createVNode("div", _hoisted_68, [
                                  _createVNode("div", _hoisted_69, [
                                    _createVNode("code", _hoisted_70, _toDisplayString(_ctx.currentAccount.bankName), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.bankName
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_71, [
                                _hoisted_72,
                                _createVNode("div", _hoisted_73, [
                                  _createVNode("div", _hoisted_74, [
                                    _createVNode("code", _hoisted_75, _toDisplayString(_ctx.currentAccount.bankAccountNumber), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.bankAccountNumber
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_76, [
                                _hoisted_77,
                                _createVNode("div", _hoisted_78, [
                                  _createVNode("div", _hoisted_79, [
                                    _createVNode("code", _hoisted_80, _toDisplayString(_ctx.currentAccount.swiftOrBic), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.swiftOrBic
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_81, [
                                _hoisted_82,
                                _createVNode("div", _hoisted_83, [
                                  _createVNode("div", _hoisted_84, [
                                    _createVNode("code", _hoisted_85, _toDisplayString(_ctx.currentAccount.transitNumber), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.transitNumber
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_86, [
                                _hoisted_87,
                                _createVNode("div", _hoisted_88, [
                                  _createVNode("div", _hoisted_89, [
                                    _createVNode("code", _hoisted_90, _toDisplayString(_ctx.currentAccount.institutionNumber), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.institutionNumber
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_91, [
                                _hoisted_92,
                                _createVNode("div", _hoisted_93, [
                                  _createVNode("div", _hoisted_94, [
                                    _createVNode("code", _hoisted_95, _toDisplayString(_ctx.currentAccount.bankAddress), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.bankAddress
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_96, [
                                _hoisted_97,
                                _createVNode("div", _hoisted_98, [
                                  _createVNode("div", _hoisted_99, [
                                    _createVNode("code", _hoisted_100, _toDisplayString(_ctx.currentAccount.phoneNumber), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.phoneNumber
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_101, [
                                _hoisted_102,
                                _createVNode("div", _hoisted_103, [
                                  _createVNode("div", _hoisted_104, [
                                    _createVNode("code", _hoisted_105, _toDisplayString(_ctx.currentAccount.postalCode), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.postalCode
                                    }, null, 8, ["text"])
                                  ])
                                ]),
                                _hoisted_106,
                                _createVNode("div", _hoisted_107, [
                                  _createVNode("div", _hoisted_108, [
                                    _createVNode("code", _hoisted_109, _toDisplayString(_ctx.currentAccount.city), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.city
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccount.type === 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_110, [
                                _hoisted_111,
                                _createVNode("div", _hoisted_112, [
                                  _createVNode("div", _hoisted_113, [
                                    _createVNode("code", _hoisted_114, _toDisplayString(_ctx.currentAccount.province), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.province
                                    }, null, 8, ["text"])
                                  ])
                                ]),
                                _hoisted_115,
                                _createVNode("div", _hoisted_116, [
                                  _createVNode("div", _hoisted_117, [
                                    _createVNode("code", _hoisted_118, _toDisplayString(_ctx.currentAccount.country), 1),
                                    _createVNode(_component_CopyToClipboard, {
                                      text: _ctx.currentAccount.country
                                    }, null, 8, ["text"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_119, [
              _createVNode("div", _hoisted_120, [
                _createVNode("div", _hoisted_121, [
                  _createVNode("div", _hoisted_122, [
                    _createVNode("button", {
                      disabled: 
                    !_ctx.withdrawalsForm.props.amount ||
                      _ctx.withdrawalsForm.invalid ||
                      (_ctx.isAdjustment && !_ctx.withdrawalsForm.props.currencyId)
                  ,
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                      class: "btn btn-success"
                    }, " Save ", 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}